module.exports = __webpack_public_path__ + "img/horizontalLogo.e8f45040.png";